const questionType = {
  READING: 'Reading',
  LISTENING: 'Listening',
};

export default questionType;
